/* eslint-disable @typescript-eslint/no-explicit-any */
import Icon from "@material-ui/core/Icon";
import { makeStyles } from "@material-ui/core/styles";
import { Launch } from "@material-ui/icons";
import { Box, Typography } from "@mui/material";
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import Card from "components/UI/Card/Card.js";
import CardFooter from "components/UI/Card/CardFooter.js";
import CardHeader from "components/UI/Card/CardHeader.js";
import CardIcon from "components/UI/Card/CardIcon.js";
import GridItem from "components/UI/Grid/GridItem";

import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import { Link, To } from "react-router-dom";

const styleAny: any = styles;
const useStyles = makeStyles(styleAny);

interface StatCardProps {
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  color: "warning" | "success" | "danger" | "info" | "primary";
  icon: string;
  statLink?: {
    href: string;
  };
  content: any;
  statText: string;
  value: string | number;
  isLoading: boolean;
  to?: To;
  onClick?: () => void;
}

function StatCard({
  color,
  icon,
  statLink,
  statText,
  value,
  content,
  isLoading,
  to,
  onClick,
  ...rest
}: StatCardProps): JSX.Element {
  const classes = useStyles();
  const { t } = useTranslation("dashboard");

  return (
    <GridItem {...rest}>
      {to ? (
        <Link to={to} onClick={onClick} id={`${statText}-stat-card`}>
          <Card>
            <CardHeader color={color} stats icon>
              <CardIcon color={color}>
                <Icon>{icon}</Icon>
              </CardIcon>
              <p className={classes.cardCategory}>{t(statText)}</p>
              <h3
                className={classes.cardTitle}
                id={`${statText}-stat-card-count`}
              >
                {isLoading ? <Skeleton /> : value ? value : 0}
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                {statLink ? (
                  <a href={statLink.href} id={`${statText}-stat-card-link`}>
                    <Typography color="primary">
                      <Launch />
                      {t(content)}
                    </Typography>
                  </a>
                ) : (
                  t(content)
                )}
              </div>
            </CardFooter>
          </Card>
        </Link>
      ) : (
        <Box onClick={onClick} id={`${statText}-stat-card`}>
          <Card>
            <CardHeader color={color} stats icon>
              <CardIcon color={color}>
                <Icon>{icon}</Icon>
              </CardIcon>
              <p className={classes.cardCategory}>{t(statText)}</p>
              <h3
                className={classes.cardTitle}
                id={`${statText}-stat-card-count`}
              >
                {isLoading ? <Skeleton /> : value ? value : 0}
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                {statLink ? (
                  <a href={statLink.href} id={`${statText}-stat-card-link`}>
                    <Typography color="primary">
                      <Launch />
                      {t(content)}
                    </Typography>
                  </a>
                ) : (
                  t(content)
                )}
              </div>
            </CardFooter>
          </Card>
        </Box>
      )}
    </GridItem>
  );
}
export default StatCard;
